// todo: figure out where this should really live
import THDCustomer from '@thd-olt-global/thd-customer';
import THDStorageUtils, { COOKIE_STORAGE } from '@thd-olt-global/thd-storage-utils';

export const isAuthenticated = () => {
  try {
    const loggedIn = THDCustomer?.isLoggedIn;
    const isKMSI = THDCustomer?.isKMSI;
    const isPersisted = THDCustomer?.isPersisted;
    const isStorefrontUser = THDStorageUtils.get(COOKIE_STORAGE, { key: 'THD_STOREFRONT' }) !== 'undefined';
    return loggedIn || isStorefrontUser || (isKMSI && isPersisted);
  } catch (err) {
    return false;
  }
};

export const isLoggedIn = () => {
  try {
    const loggedIn = THDCustomer?.isLoggedIn;
    return loggedIn;
  } catch (err) {
    return false;
  }
};

export const updateQueryParams = (path, params) => {
  const paramNames = params.map((p) => p.paramName); // eslint-disable-line id-length

  const [pathname, query = ''] = path.split('?');
  const queryParams = query.split('&').filter((p) => p); // eslint-disable-line id-length
  const updatedParams = [
    ...queryParams
      .filter((queryParam) => {
        const parts = queryParam.split('=');
        return paramNames.indexOf(parts[0]) === -1;
      }),
    ...params
      .filter((p) => p.paramValue) // eslint-disable-line id-length
      .map((param) => {
        return `${param.paramName}=${param.paramValue}`;
      })
  ].join('&');
  return pathname + '?' + updatedParams;
};
